import { z } from 'zod';

export const receiptFormSchema = z.object({
  receiptId: z.string().optional(),
  type: z.enum(['INCOME', 'EXPENSE']).default('INCOME'),
  categoryId: z.string().optional().nullable(),
  sourceType: z.string().optional().nullable(),
  customerId: z.string().min(1, { message: 'Khách hàng không được để trống' }),
  amount: z.number().min(1, { message: 'Số tiền phải lớn hơn 0' }),
  receiptDate: z.string().min(1, { message: 'Ngày thu không được để trống' }),
  paymentMethod: z.enum(['TIEN_MAT', 'CHUYEN_KHOAN', 'CAN_TRU'], { required_error: 'Vui lòng chọn phương thức thanh toán' }),
  referenceNumber: z.string().optional().nullable(),
  notes: z.string().optional().nullable(),
  attachments: z.array(z.any()).optional().default([]),
  status: z.enum(['DRAFT', 'COMPLETED', 'CANCELLED', 'CONFIRMED']).default('COMPLETED'),
});

export type ReceiptFormData = z.infer<typeof receiptFormSchema>;

export interface Receipt {
  id: string;
  receiptId: string;
  type: 'INCOME' | 'EXPENSE';
  categoryId?: string | null;
  sourceType?: string | null;
  customerId: string;
  amount: number | string;
  receiptDate: string;
  paymentMethod: 'TIEN_MAT' | 'CHUYEN_KHOAN' | 'CAN_TRU';
  referenceNumber?: string | null;
  notes?: string | null;
  attachments?: any[] | null;
  status: 'DRAFT' | 'COMPLETED' | 'CANCELLED' | 'CONFIRMED';
  customer?: { id: string; name: string; code: string; shortName?: string };
  createdAt: string;
  updatedAt: string;
}

export const debtReconciliationSchema = z.object({
  code: z.string().optional(),
  customerId: z.string(),
  month: z.number(),
  year: z.number(),
  openingBalance: z.number().default(0),
  totalIncurred: z.number().default(0),
  totalPaid: z.number().default(0),
  closingBalance: z.number().default(0),
  status: z.enum(['DRAFT', 'CONFIRMED']).default('DRAFT'),
});

export type DebtReconciliationFormData = z.infer<typeof debtReconciliationSchema>;

export interface DebtReconciliation {
  id: string;
  code: string;
  customerId: string;
  month: number;
  year: number;
  openingBalance: number;
  totalIncurred: number;
  totalPaid: number;
  closingBalance: number;
  status: 'DRAFT' | 'CONFIRMED';
  customer?: { id: string; name: string; code: string; shortName?: string };
  createdAt: string;
  updatedAt: string;
}
